import Vue from 'vue';

import {
  Button,
  Tab,
  Tabs,
  Loading,
  Swipe,
  SwipeItem,
  Icon,
  Popup,
  NavBar,
  Empty,
  Calendar,
  Circle,
  Toast,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Image as VanImage,
  ImagePreview,
  Field,
  Overlay,
  CellGroup,
  Cell,
  List,
  Switch,
  SwipeCell,
  Notify,
  ActionSheet,
  Search,
  Uploader
} from 'vant';
Vue.use(Field);
Vue.use(Empty);
Vue.use(Button);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Loading);
Vue.use(Swipe);
Vue.use(Icon);
Vue.use(SwipeItem);
Vue.use(Popup);
Vue.use(NavBar);
Vue.use(Calendar);
Vue.use(Toast);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(VanImage);
Vue.use(ImagePreview);
Vue.use(Circle);
Vue.use(Overlay);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(List);
Vue.use(Switch);
Vue.use(SwipeCell);
Vue.use(Notify);
Vue.use(ActionSheet);
Vue.use(Search);
Vue.use(Uploader);
